import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/es';

const Initializei18n = (languagePreferenceOptions) => {
	i18n
		.use(Backend)
		.use(LanguageDetector)
		.use(initReactI18next)
		.init({
			debug: false,
			ns: ['employeeSettings'],
			detection: languagePreferenceOptions,
			fallbackLng: 'en',
			backend: {
				loadPath: process.env.NODE_ENV === 'production' ? '/employeeSettings/locales/{{lng}}/{{ns}}.json' : 'locales/{{lng}}/{{ns}}.json'
			},
			interpolation: {
				escapeValue: false
			},
			react: {
				useSuspense: false
			}
		});
	moment.locale(getActiveLanguage());
};

const getActiveLanguage = () => {
	return i18n.language || (typeof window !== 'undefined' && window.localStorage.i18nextLng) || 'en';
};

async function InitializeReacti18n() {
	const languagePreferenceOptions = {
		order: ['cookie'],
		lookupCookie: 'paycorCulture'
	};
	Initializei18n(languagePreferenceOptions);
}

export default InitializeReacti18n;
